/// <reference types="../../../node_modules/@types/googlemaps" />
import { Place } from './../itineray.model';

import { Component, OnInit, Inject, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as firebase from "firebase/app";
import "firebase/firestore";

import { MapsAPILoader } from '@agm/core';

export interface LatLngPickerDialogData {
  place: Place;
  searchText: string;
}

@Component({
  selector: 'app-lat-lng-picker-dialog',
  templateUrl: './lat-lng-picker-dialog.component.html',
  styleUrls: ['./lat-lng-picker-dialog.component.css']
})
export class LatLngPickerDialogComponent implements OnInit {

  public center: firebase.firestore.GeoPoint;

  @ViewChild("searchbox")
  public searchElementRef: ElementRef;

  private autocomplete: google.maps.places.Autocomplete;

  constructor(
    private dialogRef: MatDialogRef<LatLngPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LatLngPickerDialogData, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone) { }

  ngOnInit() {
    // initial data
    if (this.data.place) {
      this.center = this.data.place.position;
      if (this.data.place.name && this.data.place.address) {
        this.data.searchText = this.data.place.name + ", " + this.data.place.address;
      } else if (this.data.place.name) {
        this.data.searchText = this.data.place.name
      }
    }

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        fields: ["name", "geometry", "place_id", "formatted_address"]
      });

      this.autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          const place: google.maps.places.PlaceResult = this.autocomplete.getPlace();

          //verify result
          if (place.geometry) {
            //set latitude, longitude and zoom
            this.setPlace(place.geometry.location.lat(), place.geometry.location.lng(), place.place_id, place.name, place.formatted_address);
            this.center = this.data.place.position;
          }

        });
      });
    });
  }

  createMarker($event) {
    this.setPlace($event.coords.lat, $event.coords.lng);
  }

  markerDragEnd($event) {
    this.setPlace($event.coords.lat, $event.coords.lng);
  }

  setPlace(lat: number, lng: number, id: string = null, name: string = null, address: string = null) {
    if (!this.data.place) {
      this.data.place = { position: null };
    }
    this.data.place.id = id;
    this.data.place.position = new firebase.firestore.GeoPoint(lat, lng);
    this.data.place.name = name;
    this.data.place.address = address;
  }

  close(): void {
    this.dialogRef.close();
  }

  onMapReady(map) {
    this.autocomplete.bindTo('bounds', map);
    if (!this.data.place) {
      const elm = this.searchElementRef.nativeElement;
      setTimeout(() => { elm.focus(); }, 1000); // FIXME
    }
  }


}
